
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		value: {
			type: String,
		}
	},
	computed: {
		tabs():ISelectItem<string | null>[]{
			let result:ISelectItem<string | null>[] = [
				{
					text: this.$ct("example"),
					value: null
				}
			];
			let tabs:string[] = [
				"pageSettings",
				"textBlocks",
				"barcodes",
				"qrcodes",
				"images",
				"zpl",
				"epson",
			];
			return result.concat(tabs.map(t=>{
				return {
					text: this.$ct(t),
					value: t
				} as ISelectItem<string>;
			}));
		}
	},
	methods: {
		clicked(t:string | null){
			this.$emit("input", t);
		}
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
